import React, { useContext } from 'react';
import { IconExclamationMark } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useWindowDimensions } from '@app/hooks';
import { CButton, CImage } from '@app/components/Common';
import { COLORS } from '@app/constants';
import { Text, View } from '@/styles/reactnative';
import { AccountSecurityListItemSection, InfoLeftLists } from './styles';
import { ThemeContext } from '@/theme/ThemeProvider';
import styled from 'styled-components';
import { MobileCalVW, useIsMobile, useIsTablet } from '@utils/CalVW.tsx';
import { media } from '@/styles/Qtheme.ts';

interface IProps {
  item?: any;
  index?: number;
}

const AccountSecurityListItems = ({ item, index }: IProps) => {
  const { borderColor, textw } = useContext(ThemeContext).theme.COLORS;
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const isTablet = useIsTablet();
  const isMobile = useIsMobile();

  return (
    <AccountSecurityListItemSection>
      <InfoLeftLists>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          {/*<CImage*/}
          {/*  src={item?.image}*/}
          {/*  alt="logo"*/}
          {/*  width={35}*/}
          {/*  height={35}*/}
          {/*  resizeMode={"cover"}*/}
          {/*  style={{ borderRadius: 50, marginRight: 10 }}*/}
          {/*/>*/}

          {!isMobile && (
            <IconWrap>
              <IconSVG as={item.image} />
            </IconWrap>
          )}

          <TitleWrap>
            {isMobile ? (
              <MobileTitleWrap>
                <IconWrap>
                  <IconSVG as={item.image} />
                </IconWrap>
                <Text size={16} style={{ fontWeight: '500' }}>
                  {item?.title}
                </Text>
              </MobileTitleWrap>
            ) : (
              <Text size={16} style={{ fontWeight: '500' }}>
                {item?.title}
              </Text>
            )}

            {item?.desc ? <DescText>{item?.desc}</DescText> : null}

            {isTablet && (
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Text
                  style={{
                    color: item?.contentColor
                      ? item?.contentColor
                      : COLORS.lightGray,
                  }}
                  size={14}
                >
                  {item?.content}
                </Text>
              </View>
            )}
          </TitleWrap>
        </View>

        <View
          style={{
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {!isTablet && (
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  color: item?.contentColor
                    ? item?.contentColor
                    : COLORS.lightGray,
                }}
                size={14}
              >
                {item?.content}
              </Text>
            </View>
          )}
        </View>
      </InfoLeftLists>

      <View
        style={{
          justifyContent: width < 970 ? 'flex-start' : 'flex-end',
          alignItems: width < 970 ? 'flex-end' : 'flex-end',
          marginLeft: 45,
          marginTop: -15,
        }}
      >
        {item?.button && (
          // <CButton
          //   title={t(item.button?.title)}
          //   onClick={() => {
          //     if (item?.button?.modelOpen) item?.button?.modelOpen();
          //   }}
          //   style={{
          //     whiteSpace: "nowrap",
          //     background:
          //       item?.button.title.slice(0, 1) === "c"
          //         ? borderColor
          //         : COLORS.primary,
          //     paddingBlock: width < 980 ? 4 : 7,
          //     paddingInline: width < 980 ? 7 : 15,
          //     alignSelf: "flex-end",
          //     fontSize: width < 980 ? 10 : 14,
          //     color: COLORS.white,
          //     marginTop: width > 600 ? 10 : 0,
          //   }}
          // />

          <CustomButton
            onClick={() => {
              if (item?.button?.modelOpen) item?.button?.modelOpen();
            }}
          >
            {t(item.button?.title)}
          </CustomButton>
        )}
      </View>
    </AccountSecurityListItemSection>
  );
};

export default AccountSecurityListItems;

const MobileTitleWrap = styled.div`
  display: flex;
  width: ${MobileCalVW(300)};
  align-items: center;
  margin-bottom: ${MobileCalVW(13.5)};
`;

const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 6px;

  @media ${media.mobile} {
    width: 80%;
  }
`;

const DescText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16.71px;
  color: ${({ theme }) => theme.inputPlaceholderText};

  @media ${media.mobile} {
    font-size: ${MobileCalVW(12)};
    margin-bottom: ${MobileCalVW(8)};
  }
`;

const CustomButton = styled.div`
  width: 69px;
  height: 30px;
  border-radius: 9999px;
  background-color: ${({ theme }) => theme.p2pBorder};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.text};
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  cursor: pointer;
`;

const IconWrap = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 9999px;
  background-color: ${({ theme }) => theme.p2pBorder};
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${media.mobile} {
    width: ${MobileCalVW(28)};
    height: ${MobileCalVW(28)};
  }
`;

const IconSVG = styled.svg`
  width: 24px;
  height: 24px;

  @media ${media.mobile} {
    width: ${MobileCalVW(15.27)};
    height: ${MobileCalVW(15.27)};
  }
`;
